<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片主体(表单) -->
        <md-card-content>
          <div class='info_list'>
            <h3 >
              <span>{{$I18n("basic_info_02")}}({{$I18n("acc_id")}}:{{UserInfo.user_id}})</span> 
            </h3>
            <div class="main-box">
              <!-- style="" -->
              <div class="bala-box" style="margin-left: 0px;position: relative;">
                <div class="bala-div">
                  <h4 class="bala-type">{{$I18n("my_bala")}}</h4>
                  <div class="bala-value">{{money}}</div>
                </div>
                <div class="bala-history" @click="go('/user/bills')">{{$I18n("history")}}</div>
              </div>
              <div class="bala-box" style="margin-right: 0px;position: relative;">
                <div v-if="rebate && rebate != 0" class="go-tran" @click="table_chargeItem">{{$I18n("tran_bala")}}</div>
                <div class="bala-div">
                  <h4 class="bala-type">{{$I18n("my_comm")}}</h4>
                  <div class="bala-value">{{rebate}}</div>
                </div>
                <div class="bala-history" @click="go('/vas/comm_mng')">{{$I18n("history")}}</div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>

      <md-card>
        <!-- 卡片主体(表单) -->
        <md-card-content>
          <div class='info_list'>
            <h3 >
              <span>{{$I18n("acc_mng")}}</span> 
              <i @click="modifyUser">{{$I18n("edit")}}</i>
            </h3>
            <!-- <div id='log_name'>
                <label>{{$I18n("user_id")}}</label>
                <span>{{this.UserInfo.user_id}}</span>
            </div> -->
            <div id='passwd'>
                <label>{{$I18n("password")}}</label>
                <span>********</span>
                <i @click="modifyPass">{{$I18n("edit")}}</i>
            </div>
            <div id='name'>
                <label>{{$I18n("login_name")}}</label>
                <span>{{this.UserInfo.user_name}}</span>
            </div>
            <div id='phone'>
                <label>{{$I18n("phone")}}</label>
                <span>{{this.UserInfo.user_phone}}</span>
            </div>
            <div id='email'>
                <label>{{$I18n("email")}}</label>
                <span>{{this.UserInfo.user_email}}</span>
            </div>
            <!-- <div id='secret_id'>
                <label>SecretId</label>
                <span>{{this.UserInfo.secret_id }}</span>
            </div>
            <div id='secret_key'>
                <label>SecretKey</label>
                <template v-if="see_key">
                  <span>{{this.UserInfo.secret_key}}</span>
                  <div :style="{display:'inline-block'}" @click="see_key = false">
                    <md-icon >visibility</md-icon>
                  </div>
                </template>
                <template v-else>
                  <span>******</span>
                  <div :style="{display:'inline-block'}" @click="see_key = true">
                    <md-icon >visibility_off</md-icon>
                  </div>
                </template>
            </div> -->
            <!-- <div id='balance'>
                <label>{{$I18n("balance")}}</label>
                <template v-if="see_money">
                  <span>{{money}}</span>
                  <div :style="{display:'inline-block'}" @click="see_money = false">
                    <md-icon >visibility</md-icon>
                  </div>
                </template>
                <template v-else>
                  <span>******</span>
                  <div :style="{display:'inline-block'}" @click="see_money = true">
                    <md-icon >visibility_off</md-icon>
                  </div>
                </template>
            </div> -->
          </div>
        </md-card-content>
      </md-card>

      <md-card>
        <md-card-content>
          <div class='info_list'>
            <h3 >
              <span>{{$I18n("company_info")}}</span> 
              <i v-if="!(this.UserInfo.role_id >= 10010 && this.UserInfo.role_id < 10020)" @click="modifyCompany">{{$I18n("edit")}}</i>
            </h3>
            <div id='comp_name'>
                <label>{{$I18n("company_name")}}</label>
                <span>{{comp.comp_name}}</span>
            </div>
            <div id='comp_short_name'>
                <label>{{$I18n("comp_short_name")}}</label>
                <span>{{comp.comp_short_name}}</span>
            </div>
            <div id='comp_key'>
                <label>{{$I18n("comp_key")}}</label>
                <span>{{comp.comp_key}}</span>
            </div>
            <div id='dk_key'>
                <label>{{$I18n("deivce_code")}}</label>
                <span>{{comp.dk}}</span>
            </div>
            <div id='belong_area'>
                <label>{{$I18n("belong_area")}}</label>
                <span>{{comp.country}}-{{comp.province}}-{{comp.city}}{{comp.area}}</span>
            </div>
            <div id='comp_addr'>
                <label>{{$I18n("company_address")}}</label>
                <span>{{comp.comp_addr}}</span>
            </div>
            <div id='comp_user'>
                <label>{{$I18n("leading_name")}}</label>
                <span>{{comp.comp_person}}</span>
            </div>
            <div id='comp_phone'>
                <label>{{$I18n("phone")}}</label>
                <span>{{comp.comp_phone}}</span>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <modal 
      v-show="openModal" 
      @close="modal_classicModalHide" 
      class="lg-modal" 
      :big-modal="openModalType==='import'" 
      :type="openModalType==='delete' ?'' :'rightModal'"
    >
      <template slot="header">
        <h4 class="modal-title">{{modalTitle}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <!-- 导入文件表格弹窗 -->
        <div v-if="openModalType==='passwd'">
          <modal-form-item :label='$I18n("old_password") ' :required="true">
            <md-field :class="{'md-error' : error.old_password}">
              <md-input v-model="modalData.old_password"/>
              <md-icon v-if="error.old_password">clear</md-icon>
            </md-field>
          </modal-form-item>
          <modal-form-item :label='$I18n("new_password")'>
            <md-field :class="{'md-error' : error.new_password}">
              <md-input v-model="modalData.new_password"/>
              <md-icon v-if="error.new_password">clear</md-icon>
            </md-field>
          </modal-form-item>
          <modal-form-item :label='$I18n("confirm_password")'>
            <md-field :class="{'md-error' : error.confirm_password}">
              <md-input v-model="modalData.confirm_password"/>
              <md-icon v-if="error.confirm_password">clear</md-icon>
            </md-field>
          </modal-form-item>
        </div>
        <div v-else-if="openModalType==='user'">
          <modal-form-item :label='$I18n("user_name") ' :required="true">
            <md-field :class="{'md-error' : error.user_name}">
              <md-input v-model="modalData.user_name"/>
              <md-icon v-if="error.user_name">clear</md-icon>
            </md-field>
          </modal-form-item>
          <modal-form-item :label='$I18n("phone")'>
            <md-field :class="{'md-error' : error.user_phone}">
              <md-input v-model="modalData.user_phone"/>
              <md-icon v-if="error.user_phone">clear</md-icon>
            </md-field>
          </modal-form-item>
          <modal-form-item :label='$I18n("email")'>
            <md-field :class="{'md-error' : error.user_email}">
              <md-input v-model="modalData.user_email"/>
              <md-icon v-if="error.user_email">clear</md-icon>
            </md-field>
          </modal-form-item>
        </div>
        <!-- 给自己充值(用自己的余额) -->
        <div v-else-if="openModalType==='charge'">
          <common-form-item 
            v-for="item in form_modalChargeData" 
            v-model="chargeModalData.Form[item.keys]" 
            :error="chargeModalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <!-- 名字 -->
          <modal-form-item :label='$I18n("company_name") ' :required="true">
            <md-field :class="{'md-error' : error.comp_name}">
              <md-input v-model="modalData.comp_name"/>
              <md-icon v-if="error.comp_name">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- 公司缩写 -->
          <modal-form-item :label='$I18n("comp_short_name")'>
            <md-field >
              <md-input v-model="modalData.comp_short_name"/>
              <!-- <md-icon >clear</md-icon> -->
            </md-field>
          </modal-form-item>
          <!-- 体系 -->
          <modal-form-item v-if="this.UserInfo.role_id < 10000" :label='$I18n("sys") ' :required="true">
            <md-field :class="{'md-error' : error.sys}">
              <md-input v-model="modalData.sys"/>
              <md-icon v-if="error.sys">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- KEY -->
          <modal-form-item v-if="!!this.modalData.comp_id" :label='$I18n("comp_key")'>
            <md-field>
              <md-input disabled v-model="modalData.comp_key"/>
              <!-- <md-icon v-if="error.comp_key">clear</md-icon> -->
            </md-field>
          </modal-form-item>
          <!-- DK -->
          <modal-form-item :label='$I18n("deivce_code")'>
            <md-field>
              <md-input :placeholder='$I18n("deivce_code_placehoder")' v-model="modalData.dk"/>
              <!-- <md-icon v-if="error.comp_key">clear</md-icon> -->
            </md-field>
          </modal-form-item>
          <!-- 所在地区 -->
          <modal-form-item :label='$I18n("belong_area") ' :required="true">
            <div class="md-layout">
              <md-field class="md-layout-item md-size-30" :class="{'md-error' : error.province}">
                <md-select v-model="province_code" >
                  <md-option value=""> {{$I18n("pls_select")}} </md-option>
                  <md-option v-for="(item, key) in areaData[100000]" :key="key" :value="key"> {{item}} </md-option>
                </md-select>
                <md-icon v-if="error.province">clear</md-icon>
              </md-field>
              <div class="md-layout-item md-size-5"></div>
              <md-field class="md-layout-item md-size-30" :class="{'md-error' : error.city}">
                <md-select v-model="city_code" >
                  <md-option value=""> {{$I18n("pls_select")}} </md-option>
                  <md-option v-for="(item, key) in areaData[province_code]" :key="key" :value="key"> {{item}} </md-option>
                </md-select>
                <md-icon v-if="error.city">clear</md-icon>
              </md-field>
              <div class="md-layout-item md-size-5"></div>
              <md-field class="md-layout-item md-size-30" :class="{'md-error' : error.area}">
                <md-select v-model="area_code" >
                  <md-option value=""> {{$I18n("pls_select")}} </md-option>
                  <md-option v-for="(item, key) in areaData[city_code]" :key="key" :value="key"> {{item}} </md-option>
                </md-select>
                <md-icon v-if="error.area">clear</md-icon>
              </md-field>
            </div>
          </modal-form-item>
          <!-- 公司地址 -->
          <modal-form-item :label='$I18n("company_address") ' :required="true">
            <md-field :class="{'md-error' : error.comp_addr}">
              <md-input v-model="modalData.comp_addr"/>
              <md-icon v-if="error.comp_addr">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- 负责人名字 -->
          <modal-form-item :label='$I18n("leading_name") ' :required="true">
            <md-field :class="{'md-error' : error.comp_person}">
              <md-input v-model="modalData.comp_person"/>
              <md-icon v-if="error.comp_person">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- 电话 -->
          <modal-form-item :label='$I18n("phone")'>
            <md-field >
              <md-input v-model="modalData.comp_phone"/>
            </md-field>
          </modal-form-item>
        </div>
      </template>

      <template slot="footer">
        <md-button 
          v-if="openModalType !=='import'" 
          class="md-info" :style="{'margin-right':'16px'}"  @click="modal_submit">{{$I18n("sure")}}</md-button>
        <md-button class="left-icon" @click="modal_classicModalHide">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
// import { Pagination } from "@/components";
import { Modal } from '@/components';
import json from 'v-distpicker/src/districts.js'

export default {
  components: {
    // Pagination,
    Modal,
  },
  data() {
    return {
      money:"0",
      rebate:"0",
      money_type:0,
      see_money:false,
      see_key  :false,
      areaData: {
        ...json,
        "":{},
      },
      province_code:"",
      city_code : "",
      area_code : "",
      // 表格相关
      icon  : "person",
      title : this.$I18n("personal_info"),
      compData : [], // 公司数据

      // 弹窗相关
      openModal     : false,  // 是否打开弹窗
      openModalType : "upload", // 弹窗类型
      modalTitle    : "",  // 弹窗标题
      // 弹窗表单相关
      modalData : {
        company : "",
        file : "",
        file_url : "",
      },
      // 弹窗表单报错相关
      error: {
        file : false,
      },
      // 弹窗表格数据
      modalTableInitData : [],
      import_currentPage : 1,
      import_pageSize : 10,
      import_total : 0,

      chargeModalData : new FormClass({
        your_bala  : {},
        your_commi :{},
        money_type : "USD",
        money      : 0,
        // money_obj:{},
      },{
        money : value => {
          return isNaN(value) || parseFloat(value) <= 0 
        },
        your_commi : (value, formValue) => {
          return parseFloat(formValue.your_commi[formValue.money_type]) < parseFloat(formValue.money)
        }
      }),
    };
  },
  mounted : function() {
    this.api_getComp();
    this.api_getBalance();
  },
  watch: {
    province_code(to){
      if (!this.openModal){
        return 
      }
      this.city_code = "";
      if(to){
        this.modalData.province = this.areaData[100000][to];
      } else {
        this.modalData.province = "";
      }
    },
    city_code(to){
      if (!this.openModal){
        return 
      }
      this.area_code = "";
      if(to){
        this.modalData.city = this.areaData[this.province_code][to];
      } else {
        this.modalData.city = "";
      }
    },
    area_code(to){
      if (!this.openModal){
        return 
      }
      if(to){
        this.modalData.area = this.areaData[this.city_code][to];
      } else {
        this.modalData.area = "";
      }
    },
  },
  computed: {
    comp(){
      if(this.compData.length == 0){
        return {}
      } else {
        return this.compData[0]
      }
    },
    form_modalChargeData(){
      return [
        {
          label   : this.$I18n("your_bala"),
          keys    : "your_bala_str",
          type    : "input",
          required: true,
          disabled: true,
        },{
          label   : this.$I18n("your_commi"),
          keys    : "your_commi_str",
          type    : "input",
          required: true,
          disabled: true,
        },{
          label   : this.$I18n("currency_type"),
          keys    : "money_type",
          type    : "select",
          options : [
            {id: 'CNY', name : this.$I18n("curr_name_CNY")},
            {id: 'USD', name : this.$I18n("curr_name_USD")},
            {id: 'INR', name : this.$I18n("curr_name_INR")},
            {id: 'IDR', name : this.$I18n("curr_name_IDR")},
          ].filter(i => parseFloat(this.chargeModalData.Form.your_commi[i.id]) > 0),
          placeholder: this.$I18n('pls_input_role_id'),
        },{
          label   : this.$I18n("recharge_num"),
          keys    : "money",
          type    : "input",
          required: true,
          check   : true,
        },
      ]
    },
  },
  methods: {
    go(path){
      this.$router.push({
        path: path,
        query:{...this.$router.history.current.query}
      })
    },
    table_chargeItem(){
      this.chargeModalData.Update({
        ...this.balanceInfo,
        your_bala_str : this.money,
        your_commi_str: this.rebate,
        money_type: Object.keys(this.balanceInfo.your_commi)[0] ?Object.keys(this.balanceInfo.your_commi)[0] :'',
        money:0,
      });
      this.modalTitle = this.$I18n("tran_comm_bala");
      this.openModalType = "charge";
      this.openModal = true;
    },
    api_getBalance(){
      this.$api.getBalance({})
        .then(this.$Then(res => {
          let str = "";
          let json = JSON.parse(res.data?.money ?? '{}')
          for(var key in json){
            str = str + (str ?", " :"") + this.$I18n("curr_" + key) + ": " + json[key]
          }
          if(str === ""){
            str = "0"
          }
          this.money = str;

          str = ""
          json = JSON.parse(res.data?.rebate_balance ?? '{}')
          for(var key_r in json){
            str = str + (str ?", " :"") + this.$I18n("curr_" + key_r) + ": " + json[key_r]
          }
          if(str === ""){
            str = "0"
          }

          this.rebate = str;

          this.balanceInfo = {
            your_bala: JSON.parse(res.data?.money ?? '{}'),
            your_commi:JSON.parse(res.data?.rebate_balance ?? '{}'),
          }
        }))
        .catch(this.$Catch())
    },
    // 获取公司信息
    api_getComp (){
      //获取菜单
      this.$api.getCompanyList({})
        .then(this.$Then(res => {
          this.compData = res.data.filter(item => item.comp_id == this.UserInfo.comp_id);
        }))
        .catch(this.$Catch("",() => {
          this.compData = [];
        }))
    },
    modifyUser (){
      this.openModal = true;
      this.modalTitle = this.$I18n("edit_user")
      this.openModalType = "user"
      this.modalData = {...this.UserInfo}
      this.error = {
        user_name : false,
        user_phone : false,
        user_email : false,
      }
    },
    modifyPass (){
      this.openModal = true;
      this.modalTitle = this.$I18n("modify_pw")
      this.openModalType = "passwd"
      this.modalData = {
        old_password : "",
        new_password : "",
        confirm_password : "",
      }
      this.error = {
        old_password : false,
        new_password : false,
        confirm_password : false,
      }
    },
    modifyCompany (){
      this.openModalType = "company"
      this.modalTitle = this.$I18n("modify_comp")
      this.modalData = {...this.comp}
      for(let key in this.areaData[100000]){
        if(this.areaData[100000][key] === this.comp.province){
          this.province_code = key
          break;
        }
      }
      if (this.province_code){
        for(let key in this.areaData[this.province_code]){
          if(this.areaData[this.province_code][key] === this.comp.city){
            this.city_code = key;
            break;
          }
        }
      }
      if(this.city_code) {
        for(let key in this.areaData[this.city_code]){
          if(this.areaData[this.city_code][key] === this.comp.area){
            this.area_code = key
            break;
          }
        }
      }
      this.error = {
        comp_name : false,
        sys : false,
        province : false,
        city : false,
        area : false,
        comp_addr : false,
        comp_person : false,
      }
      setTimeout(()=> {this.openModal = true},0);
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.openModal = false;
      this.error.file = false;
    },
    // 提交表单
    modal_submit () {
      if(this.openModalType == 'company'){
        let hasError = false;
        for(let key in this.error) {
          if(this.UserInfo.role_id >= 10000 && key === "comp_key") {
            continue;
          }
          this.error[key] = !this.modalData[key]
          hasError = !this.modalData[key]
        }
        if (hasError){
          this.$errorMsg(this.$I18n("pls_input_content"));
          return;
        }
        this.$api.editCompany(this.modalData)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.modal_classicModalHide();
            this.api_getPageData();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if(this.openModalType == 'user'){
        this.$api.editUser({
          ...this.UserInfo,
          ...this.modalData,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.UserInfo = {...this.modalData}
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if(this.openModalType == 'charge') {
        if(this.chargeModalData.Check()){
          if(this.chargeModalData.Error.money){
            this.$errorMsg(this.$I18n("pls_input_post_num"))
            return 
          } else {
            this.$errorMsg(this.$I18n("no_enouth_money"))
            return 
          }
        }
        this.$api.setBalance({
          ...this.chargeModalData.Form,
          currency_code: this.chargeModalData.Form.money_type,
          amount: this.chargeModalData.Form.money,
          to_comp_id: this.UserInfo.comp_id,
          type: 1,
          money_type : 2,
        })
          .then(this.$Then(() => {
            window.__regetBalace();
            this.modal_classicModalHide();
            this.$successMsg(this.$I18n("succ_num"));
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))

      }else {
        this.error.old_password = !this.modalData.old_password;
        this.error.new_passwd = !this.modalData.new_password;
        this.error.confirm_password = this.modalData.new_password !=  this.modalData.confirm_password

        for(let key in this.error) {
          if (this.error[key]){
            this.$errorMsg(this.$I18n("pls_input_content"));
            return;
          }
        }

        var sendData = {
            user_id   : this.UserInfo.user_id,
            old_passwd: this.modalData.old_password,
            new_passwd: this.modalData.new_password,
        }
        this.$api.changePassword(sendData)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.modal_classicModalHide();
            this.api_getComp();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .main-box{
    display: flex;
    width: 100%;
    border-bottom: 0 !important;
  }
  .bala-box{
    margin: 0px 20px;
    display: flex;
    justify-content: center;
  }
  .bala-div{
    padding: 50px 40px;
    line-height: 40px;
    width: 400px;
    border: 4px solid rgb(16,174,255);
    border-radius: 10px;
  }
  .bala-type{
    font-size: 18px;
    font-weight: 600;
    color: #666;
    line-height: 24px;
    position: absolute;
    top: 5px;
    left: 15px;
    padding: 10px;
  }
  .bala-value{
    font-size:20px;
    font-weight: 600;
    text-align: center;
  }
  .bala-history{
    position: absolute;
    bottom: 5px;
    left: 15px;
    padding: 10px;
    font-size: 14px;
    cursor: pointer;
    color: #30a5ff;
  }
  .go-tran{
    position: absolute;
    right: 15px;
    top: 5px;
    cursor:pointer;
    padding: 10px;
    color: #30a5ff;
  }

  /*myInfo.html 单独样式*/
      .info_list {
        margin: 0 24px;
      }
      .info_list>div{
          padding: 10px 0;
          border-bottom: .5px solid #efefef;
          line-height: 24px;
          color: rgba(0,0,0,.85);
          font-family: 'Monospaced';
      }
      .info_list label{
          display: inline-block;
          margin-right: 20px;

          color: #9b9b9b;
          font-weight: 400;
          width: 195px;
      }
      .info_list div span {
          color: #4b4b4b;
          font-weight: 400;
      }
      h3 {
        height: 50px;
        border-radius: 4px 4px 0 0;
        line-height: 50px;
        color: rgba(0,0,0,.65);
        /*border-bottom: 1px solid rgba(0,0,0,.65);*/
        margin-top: 0px;
        font-weight: 600;
        font-size: 16px;
      }
      h4 i, h3 i, .info_list i{
        /*float: right;*/
        color: #30a5ff;
        font-style: inherit;
        font-size: 14px;
        margin-left: 32px;
        cursor: pointer;
      }
  /*myInfo.html 单独样式结束*/
</style>
